module.exports = {
  getNewItem: function (data) {
    var deferred = $.Deferred();
    deferred.resolve({ source: data.source });

    return deferred.promise();
  },

  isSameModel: function (model1, model2) {
    return model1.source === model2.source;
  }
};
